export default __webpack_public_path__ + "static/media/rbt1.3ea408ce.webp";